import { Box, Text, AspectRatio } from "@chakra-ui/react";
import parse from "html-react-parser";
import { getMenus, getEventUris, getEventByUri } from "../../src/lib/dataFetch";
import Layout from "../../src/components/layout";
import Seo from "../../src/components/seo";
import {
  PostArticle,
  FeatImage,
  PostTitle,
  ArticleBody,
  EventMeta,
} from "../../src/styles/postStyles";
import { postOptions } from "../../src/lib/parseOptions";
import { useRouter } from "next/router";

export default function EventPage({ event, menus }) {
  const router = useRouter();
  const pathArray = router.asPath.split("/");
  const regexp = new RegExp(pathArray[pathArray.length - 1], "i");
  const seoTitle = `${event.title} | iDriveSoCal`;
  const featuredImage = {
    src: event.featuredImage?.node?.sourceUrl,
    alt: event.featuredImage?.node?.alt || ``,
  };
  return (
    <Layout menus={menus}>
      <Seo title={seoTitle} />
      <PostArticle
        className="blog-post"
        itemScope
        itemType="http://schema.org/Event"
      >
        <header>
          <PostTitle as="h1" px={{ base: 4, sm: 8, md: 8 }} itemProp="headline">
            {parse(event?.title)}
          </PostTitle>
          <EventMeta
            px={{ base: 4, sm: 8, md: 8 }}
            pb="6"
            textAlign="center"
            startDate={event.startDates.filter((x) => regexp.test(x))[0]}
            endDate={event?.endDate}
          />

          {featuredImage?.src && (
            <AspectRatio ratio={16 / 9}>
              <FeatImage
                src={featuredImage.src}
                alt={featuredImage.alt}
                layout="fill"
                objectFit="cover"
              />
            </AspectRatio>
          )}
        </header>

        {!!event.content && (
          <ArticleBody p={8} itemProp="articleBody">
            {parse(event?.content, postOptions)}
          </ArticleBody>
        )}

        <hr />
      </PostArticle>
      <Box
        mx="auto"
        py="4"
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
      >
        <Text pr="4" textTransform="uppercase">
          Share:
        </Text>{" "}
        <div className="s9-widget-wrapper"></div>
      </Box>
    </Layout>
  );
}

export async function getStaticProps(context) {
  const menus = await getMenus();
  const uri = `/event/${context.params.uri.join("/")}`;
  const event = await getEventByUri(uri);

  return {
    props: {
      event,
      menus,
    },
  };
}

export async function getStaticPaths() {
  const events = await getEventUris();
  const paths = events.map((event) => {
    const regex = /(^\/event\/)/;
    const eventUri = event.uri.replace(regex, "");
    const uri = eventUri.split("/");
    return {
      params: {
        uri: uri,
      },
    };
  });
  return { paths, fallback: false };
}
